interface WSMessage {
  event: string;
  data: unknown;
}

export const parseMessage = (e: MessageEvent): WSMessage | null => {
  try {
    return JSON.parse(e.data);
  } catch {
    return null;
  }
};
